import { render, staticRenderFns } from "./file-input-tertiary.vue?vue&type=template&id=1c175aea&scoped=true&"
import script from "./file-input-tertiary.vue?vue&type=script&lang=js&"
export * from "./file-input-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c175aea",
  null
  
)

export default component.exports